@for (question of rows; track question) {
  <mat-expansion-panel
    class="expansion-panel"
    [expanded]="question.isOpen"
  >
    <mat-expansion-panel-header class="expansion-panel-header">
      <div class="text-md-bold">{{ question.question }}</div>
    </mat-expansion-panel-header>
    <div
      class="expansion-panel-description"
      [innerHTML]="question.answer"
    ></div>
  </mat-expansion-panel>
}
